<template>
    <header id="header" class="app-header">
        <div class="container py-2">
            <div class="row">
                <div class="col-12 col-sm-8">
                    <div class="row">
                        <div class="col-12 col-md-6 logo-container">
                            <a href="/" class="logo">
                                <img
                                    src="/images/logo-followme.svg"
                                    alt="Logo Follow Me"
                                    :title="$t('followme_title')"
                                    class="w-100"
                                />
                            </a>
                        </div>

                        <div class="font-weight-bold col-12 col-md-6 pl-lg-0 title">
                            <span :class="'vehicle-type-icon icon-' + icon" v-if="icon"></span>
                            <span class="title-text">{{ $t(title) }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-4 menus">
                    <b-nav pills class="ml-auto width-fit-content">
                        <b-nav-item-dropdown
                            id="my-nav-dropdown"
                            :text="currentLanguage"
                            toggle-class="nav-link-custom"
                            class="lang-dropdown"
                            right
                        >
                            <b-dropdown-item @click="changeLanguage('pl')">
                                {{ $t('lang_pl') }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="changeLanguage('en')">
                                {{ $t('lang_en') }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="changeLanguage('de')">
                                {{ $t('lang_de') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>

                        <b-nav-item :to="{ name: 'login.index' }" v-if="!isLoggedIn">
                            {{ $t('auth.login') }}
                        </b-nav-item>

                        <b-nav-item :to="{ name: 'register.index' }" v-if="!isLoggedIn && !(isSuperAdmin || isAdmin)">
                            {{ $t('auth.register') }}
                        </b-nav-item>

                        <b-nav-item-dropdown
                            id="my-nav-dropdown"
                            text="Admin"
                            toggle-class="nav-link-custom"
                            right
                            v-if="isSuperAdmin || isAdmin"
                        >
                            <b-dropdown-item href="/manage/admins" v-if="isSuperAdmin">
                                {{ $t('admin_panel') }}
                            </b-dropdown-item>

                            <b-dropdown-item href="/manage/bt/discount-codes" v-if="isAdmin">
                                {{ $t('admin_panel') }}
                            </b-dropdown-item>

                            <b-dropdown-item @click="submitLogoutForm">
                                {{ $t('auth.logout') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>

                        <b-nav-item-dropdown
                            id="my-nav-dropdown"
                            :text="truncatedUserName"
                            toggle-class="nav-link-custom"
                            right
                            v-if="isLoggedIn"
                        >
                            <b-dropdown-item :to="{name: 'user_data'}">
                                {{ $t('user_data.header') }}
                            </b-dropdown-item>

                            <b-dropdown-item :to="{name: 'users_orders', params: {offerType: 'bt'}}">
                                {{ $t('orders.bt.my_orders') }}
                            </b-dropdown-item>

                            <b-dropdown-item :to="{name: 'users_orders', params: {offerType: 'fat'}}" v-if="!isCompany">
                                {{ $t('orders.fat.my_orders') }}
                            </b-dropdown-item>

                            <b-dropdown-item :to="{name: 'users_orders', params: {offerType: 'berbus'}}">
                                {{ $t('orders.berbus.my_orders') }}
                            </b-dropdown-item>

                            <b-dropdown-item href="/user/invoice/edit" v-if="isCompany && false">
                                {{ $t('auth.profile.invoice_info') }}
                            </b-dropdown-item>

                            <b-dropdown-item @click="submitLogoutForm">
                                {{ $t('auth.logout') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-nav>

                    <form action="/logout/admin" method="POST" class="d-none" ref="logoutForm">
                        <input type="hidden" name="_token" :value="csrf">
                    </form>
                </div>
            </div>
        </div>
    </header>
</template>


<script>
    import { mapGetters } from 'vuex';
    import backofficeRepository from '@repositories/BackofficeRepository';

    export default {
        data() {
            return {
                csrf: document.head.querySelector('meta[name="csrf-token"]').content,
                title: '',
                icon: null,
                currentLanguage: window.APP.locale,
            };
        },

        computed: {
            ...mapGetters({
                getUserId: 'user/getId',
                getUserName: 'user/getName',
                role: 'user/getRole',
                isCompany: 'user/isCompany',
                isLoggedIn: 'user/isLoggedIn',
                isSuperAdmin: 'user/isSuperAdmin',
                isAdmin: 'user/isAdmin',
            }),
            truncatedUserName() {
                //remove domain part from email address of getUserName and restrict to 24 chars adding ... at the end when overflowing
                const name = this.getUserName.split('@')[0];
                return name.substring(0, 24) + (name.length > 24 ? '...' : '');
            },
        },

        methods: {
            async submitLogoutForm() {
                backofficeRepository.removeLoginToken();
                await this.$store.dispatch('user/unsetUser');
                this.$refs.logoutForm.submit();
            },
            async changeLanguage(lang) {
                await this.$store.dispatch('berbus/reset');
                await this.$store.dispatch('businessTaxi/reset');
                await this.$store.dispatch('airportTransfersSearch/reset');
                await this.$store.dispatch('familyAirportTaxi/reset');
                window.location.href = `/lang/${lang}`;
            },
        },

        mounted() {
            this.title = this.$router.currentRoute.meta.title;
            this.icon = this.$router.currentRoute.meta.icon;
        },

        watch:{
            $route (to, from){
                this.title = to.meta.title;
                this.icon = to.meta.icon;
            },
        },
    };
</script>

